import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * /scenarios 配下のレイアウト。
 * 一覧（index）・ビルダー（$scenarioId）・生成（new）は同階層の兄弟ルートで、
 * この Outlet に差し替わる。
 */
export const Route = createFileRoute("/scenarios")({
  component: ScenariosLayout
});

function ScenariosLayout() {
  return <Outlet />;
}
